// components/EmptyState.jsx
import React from 'react';
import { Empty } from '@arco-design/web-react';

const EmptyState = ({
  description = 'No Data',
  icon = null,
  style = {},
  className = '',
}) => {
  return (
    <Empty
      description={description}
      icon={icon}
      style={style}
      className={className}
    />
  );
};

export default EmptyState;
